
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ["features"],

  methods: {
    toggle(key) {
      this.features[key] = !this.features[key];
    }
  }
};
